var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "g-title" }, [
    _c("div", { staticClass: "g-img", class: _vm.bg }),
    _c("span", { staticClass: "title" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }